import { gql, useQuery } from '@apollo/client';
import { USD } from '@dinero.js/currencies';
import { Currency } from 'dinero.js';

import { getCurrencyFromCurrencyCode } from '@/utilities/getCurrencyFromCurrencyCode';

import { useDefaultCurrency_Query } from './graphql-types/useDefaultCurrency_Query';

const QUERY = gql`
  query useDefaultCurrency_Query {
    tenant {
      result {
        _id
        paymentDefaultCurrencyV2
      }
    }
  }
`;

export const useDefaultCurrency = (): {
  isLoading: boolean;
  currency: Currency<number>;
} => {
  const query = useQuery<useDefaultCurrency_Query>(QUERY);
  const code = query.data?.tenant.result?.paymentDefaultCurrencyV2;

  return {
    isLoading: query.loading,

    currency: code ? getCurrencyFromCurrencyCode(code as string) : USD,
  };
};
